export const DELETE_DMX_UNIVERSE = 'DELETE_DMX_UNIVERSE';
export const DELETE_DMX_UNIVERSE_SUCCESSFUL = 'DELETE_DMX_UNIVERSE_SUCCESSFUL';
export const DELETE_DMX_UNIVERSE_FAILED = 'DELETE_DMX_UNIVERSE_FAILED';
